<template>
  <div class="items-table-container">
    <vuetable
      ref="vuetable"
      :fields="columns"
      :api-mode="false"
      :data="Items"
      id="order-items-table"
      track-by="order_number"
      detail-row-component="detail-row-component"
      @vuetable:row-clicked="bubbleUp($event)"
    ></vuetable>
  </div>
</template>
<script>
import vuetable from "vuetable-2/src/components/Vuetable";
import OrderItems from "../../data/ordered_items.json";

export default {
  components: {
    vuetable
  },
  props: {
    order_number: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      columns: [
        {
          name: "name",
          title: "Item",
          dataClass: "price-row"
        },
        {
          name: "price",
          title: "Price",
          dataClass: "price-row",
          formatter(value) {
            return value.toFixed(2) + " CHF";
          }
        },
        {
          name: "temperature_band",
          title: "Temperature Band"
        },
        {
          name: "allowed_time_outside",
          title: `Time allowed 
          out of band`,
          formatter(value) {
            return value + " hr";
          }
        }
      ]
    };
  },
  computed: {
    Items() {
      return OrderItems.filter(x => x.order_number === this.order_number);
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/_variables.scss";

.items-table-container {
  display: flex;
  min-height: 310px;
  max-height: 310px;
  overflow-y: scroll;
}
#order-items-table {
  border: none;
  width: 90%;
  table {
    padding-bottom: 10px;
    background-color: #fff;
  }
  tr {
    border: none;
    cursor: default;
    border-bottom: 1px solid whitesmoke;
  }
  th {
    padding-bottom: 10px;
  }
  td {
    padding: 10px 20px;
  }
}

.price-row {
  white-space: nowrap;
}
</style>
